import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { TextView } from 'src/core/ui/text.view';
import { MapDialogView } from 'src/core/ui/map-dialog.view';
import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller'
import { DropdownView } from 'src/core/ui/dropdown.view';

interface PlaceFormViewProps extends ComponentViewProps<any> {
	title: string,
	save: () => void,
	cancel: () => void,
	model: any;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
}

@observer
export class PlaceFormView extends React.Component<PlaceFormViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		if (model == null) return null;
		const mode = this.props.mode;
		const displayNames = (model as any).dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [{ title: 'Title', dynamicProperties: displayNames, required: true }];
		const type = (model as any).type;

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 6, span: 12 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						{
							model != null &&
							<CardController
								mode={this.props.mode}
								icon="book"
								title="General information">
								<Row gutter={16}>
									<Col xs={24}>
										<TabLanguageController model={this.props.model}
											dynamicProperties={array}
											mode={mode}
											setBusy={this.props.setBusy}
											isRichTextBox={false}
										/>
									</Col>
									{
										type == 1 &&
										<Col xs={24} lg={12}>
											<TextView
												onGetErrorMessage={() => this.props.model.validate('code')}
												mode={mode}
												label="Code"
												value={model.code}
												onChanged={newVal => model.code = newVal}
												required
											/>
										</Col>
									}
									<Col xs={24} lg={type == 1 ? 12 : 24}>
										<RegionEditorController
											onChanged={(value) => { model.regionId = value != null ? value.id : null }}
											value={model.regionId}
											setBusy={this.props.setBusy}
											mode={mode}
										/>
									</Col>
									<Col xs={24}>
										<MapDialogView
											location={model.location}
											onChangeLocation={e => model.location = e}
											mode={this.props.mode}
											zoom={13}
										/>
									</Col>
									<Col xs={24} lg={24}>
										<PlaceEditorController
											label="Parent place"
											mode={mode=="edit"&&model.regionId ? 'edit' : 'display'}
											onChanged={(value) => { model.parentPlaceId = value != null ? value.id : null }}
											value={model.parentPlaceId}
											setBusy={this.props.setBusy}
											regionId={model.regionId}
											type={[0]}
										/>
									</Col>
									{
										type != 1 && <Col xs={24} lg={24}>
											<DropdownView
												label={"Type"}
												required
												model={(model as any).type}
												disabled={mode == "display"}
												onChanged={(item) => {
													(model as any).type = item.value;
												}}
												options={
													[
														{ value: 0, label: 'General' },
														{ value: 2, label: 'Resort' },
														{ value: 3, label: 'Transfer Point' },
														{ value: 4, label: 'Coach Pickup Point' },
													]
												}
											/>
										</Col>}
								</Row>
							</CardController>
						}
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/places/form/place-form.view.tsx